var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-panel-outer"},[_c('div',{staticClass:"group-panel"},[_c('div',{staticClass:"group-panel-title"},[(_vm.labelKey)?_c('t',{attrs:{"k":_vm.labelKey}}):(_vm.label)?[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"group-panel-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }